import gsap from 'gsap';
import { throttle } from 'throttle-debounce';

import accordions from '../../components/accordions';
import pageHeader from '../../components/page-header';
import pageContent from '../../components/page-content';

const els = {
    $anchors: () => $('[data-sidebar-anchor]'),
    $activeAnchor: () => els.$anchors().find('[data-active]'),
    $icons: () => $('[data-sidebar-anchor-icon]'),
    $icon: ($anchor) => $anchor.find('[data-sidebar-anchor-icon]'),
};

const shouldUseAccordionBehavior = () => (
    accordions.isAccordion(
        pageContent.els.$firstContentSectionChild()
    )
);

const deactivateAllAnchors = () => {
    const $anchors = els.$anchors();
    const $icons = els.$icons();

    $anchors.attr('data-active', '0');
    gsap.set($icons, { clearProps: 'all' });
};

const activateAnchor = ($anchor) => {
    const $anchors = els.$anchors();
    const $activeAnchor = els.$activeAnchor();

    if ($anchor.is($activeAnchor)) {
        return;
    }

    $anchors.attr('data-active', '0');
    $anchor.attr('data-active', '1');

    const $icon = els.$icon($anchor);
    const $otherIcons = els.$icons().not($icon);

    gsap.set($otherIcons, { clearProps: 'all' });

    gsap.set(
        $icon,
        {
            scale: 1,
            opacity: 1,
        }
    );
};

const activateAnchorBasedOnAccordion = () => {
    const $accordion = pageContent.els.$firstContentSectionChild();
    const $activeAccordionItem = accordions.els.$activeItem($accordion);

    deactivateAllAnchors();

    if ($activeAccordionItem.length === 0) {
        return;
    }

    const id = $activeAccordionItem.attr('id');
    const $anchor = els.$anchors().filter(`[href="#${id}"]`);

    activateAnchor($anchor);
};

const activateAnchorBasedOnScroll = () => {
    const $anchors = els.$anchors();
    const $pageHeader = pageHeader.els.$header();

    const windowHeight = $(window).height();

    const threshold = (
        $pageHeader.outerHeight()
        + 100
    );

    const $closest = $anchors.toArray().reduce(
        ($closest, anchor, index) => {
            const $anchor = $(anchor);

            if ($closest === null) {
                return $anchor;
            }

            const href = $anchor.attr('href');
            const $target = $(href);

            if ($target.length === 0) {
                return $closest;
            }

            const targetTop = $target.offset().top;

            const targetBottom = (
                targetTop
                + $target.outerHeight()
            );

            const isLastTarget = index === $anchors.length - 1;

            if (
                targetTop <= threshold
                || (
                    isLastTarget
                    && targetBottom <= windowHeight
                )
            ) {
                return $anchor;
            }

            return $closest;
        },
        null
    );

    if ($closest === null) {
        return;
    }

    activateAnchor($closest);
};

const initializeWithAccordionBehavior = () => {
    const $accordion = pageContent.els.$firstContentSectionChild();

    activateAnchorBasedOnAccordion();

    $accordion.on(
        'accordion.item.open accordion.item.close',
        activateAnchorBasedOnAccordion
    );
};

const initializeWithScrollBehavior = () => {
    activateAnchorBasedOnScroll();

    pageContent.els.$content().on(
        'scroll',
        throttle(50, activateAnchorBasedOnScroll)
    );

    $(window).on(
        'resize:horizontally',
        throttle(50, activateAnchorBasedOnScroll)
    );
};

const initialize = () => {
    if (shouldUseAccordionBehavior()) {
        initializeWithAccordionBehavior();
    } else {
        initializeWithScrollBehavior();
    }
};

export default {
    initialize,
};

